import CreateEnquiryForm from "components/CreateEnquiryForm/CreateEnquiryForm";
import React from "react";

export default function CreatePackage() {
  return (
    <div>
      <CreateEnquiryForm Package={true} />
    </div>
  );
}
